<template>
  <div class="row justify-content-center">
    <div class="col-12 col-md-11 col-sm-12 col-xs-12">
      <ClienteList />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ClienteList from "../../../../_shared/features/ClienteList.vue";

export default {
  name: "ClientesAdmin",
  components: { ClienteList },
  data() {
    return {};
  },
  methods: {},
};
</script>
